import { ClubApi } from "api/ClubApi";

export default {
    isPeriodeReaffiliation: new Date().getMonth() === 11,// Décembre == 11 (0->11)
    isCreditSuffisant: (club, cost) => club?.clubCredit >= cost,
    GetClubWithId: (id) => ClubApi.get(id),
    //GetMembers: (idClub, annee, isValidOnly) => useFetch(`/api/clubs/${id}/members?year=${reaffiliationYear}&actifOnly=${false}`)
}